import BaseMapper from './base';
import { Component, PageModularProps } from '../types';

class PageModular extends BaseMapper {
  public async generateComponent(): Promise<Component<PageModularProps>> {
    const props = {} as PageModularProps;
    const childrens = await this.renderChildrenFromId();

    return {
      name: 'PageModular',
      props,
      childrens,
    };
  }
}

export default PageModular;
